import { Observable } from 'rxjs';
import { RegistrationInformationMultiOptionsFieldsValuesResponse } from '../../model/login-register.model';

export abstract class RegistrationInformationMultiOptionFieldsValuesAdapter {
  abstract loadRegistrationInformationMultiOptionFieldsValues(): Observable<RegistrationInformationMultiOptionsFieldsValuesResponse>;
}
